var _style, _path, _path2, _rect, _path3, _g, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTartCherryJuice({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D5E2DA;}\n\t.st1{fill:#DE2F45;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#78B355;}\n\t.st4{fill:#70921A;}\n\t.st5{fill:#BE1823;}\n\t.st6{fill:#E05062;}\n\t.st7{fill:none;stroke:#891415;stroke-width:2.4382;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st8{fill:none;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.08,182.45c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C28.78,148.16,63.39,182.45,106.08,182.45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M128.28,74.46c2.22,0.96,4.03,3.38,4.03,5.37v79.25c0,1.99-2.07,3.62-4.61,3.62H81.83 c-2.53,0-4.61-1.63-4.61-3.62V79.82c0-1.99,1.81-4.4,4.03-5.36l8.61-3.73c2.22-0.96,4.03-3.38,4.03-5.36v0.24 c0-1.99-1.66-3.62-3.68-3.62c-2.03,0-3.68-1.63-3.68-3.62v-5.28c0-1.99,2.07-3.62,4.61-3.62h27.31c2.53,0,4.61,1.63,4.61,3.62v5.28 c0,1.99-1.66,3.62-3.68,3.62c-2.03,0-3.68,1.63-3.68,3.62v-0.24c0,1.99,1.81,4.4,4.03,5.37L128.28,74.46z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 81.77,
    y: 85.69,
    className: "st2",
    width: 46,
    height: 67.31
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M119.03,63.72H90.5c-3.57,0-6.49-2.92-6.49-6.49v-2.25c0-3.57,2.92-6.49,6.49-6.49h28.53 c3.57,0,6.49,2.92,6.49,6.49v2.25C125.52,60.8,122.6,63.72,119.03,63.72z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M99.52,109.69c11.41,4.85,14.29-10.98,14.29-10.98C99.06,98.49,99.52,109.69,99.52,109.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M115.3,97.48c-0.36-0.44-0.9-0.7-1.47-0.71c-5.6-0.08-9.9,1.36-12.76,4.3c-3.65,3.74-3.5,8.5-3.49,8.7 c0.03,0.75,0.49,1.42,1.18,1.71c0.27,0.11,0.53,0.22,0.8,0.31c3.23,1.17,6.18,1.01,8.78-0.49c5.69-3.27,7.32-11.88,7.39-12.25 C115.82,98.5,115.67,97.92,115.3,97.48z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M117.58,125.47c2.48,7-1.19,14.68-8.18,17.16c-7,2.48-14.68-1.19-17.16-8.18c-0.7-1.98-1.24-4.12-1-6.24 c0.23-2,1.2-3.68,2.52-5.16c0.91-1.02,2.15-1.68,3.49-1.9c1.49-0.24,3.03,0.21,4.5-0.21c1.1-0.32,1.64-1.5,2.52-2.14 c1.72-1.27,4.39-1.44,6.4-0.93C114.25,118.77,116.42,122.19,117.58,125.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M108.7,121.8c-0.65-0.18-1.32,0.19-1.5,0.83c-0.18,0.64,0.19,1.32,0.83,1.5c1.16,0.33,1.94,1.09,2.29,2.24 c0.18,0.59,0.77,0.94,1.36,0.84c0.05-0.01,0.11-0.02,0.16-0.04c0.64-0.2,1-0.88,0.8-1.52C111.84,123.05,109.83,122.12,108.7,121.8 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M102.27,121.41c-1.34-2.29-3.39-6.48-3.97-12.11c-0.68-6.67,1.06-11.89,2.1-14.44"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M77.08,123.58c0,0-0.19,0.13-0.45,0.29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTartCherryJuice);
export default __webpack_public_path__ + "static/media/Tart_cherry_juice.5f3f1ad0743ef5db2494073ff4b86bc7.svg";
export { ForwardRef as ReactComponent };